import React, { useContext } from "react";
import SellAssetItem from "./sellAssetItem";
import { TownContext } from "../../shared/townContext";

const SellGoods = ({ town, name }) => {
  let { property } = useContext(TownContext)
  const sellEndpoint = `/students/towns/${town.id}/properties/${property.id}/goods/sell`
  const marketPriceEndpoint = `/students/towns/${town.id}/markets/good_prices?name=${name}`

  return (<>
    <SellAssetItem name={name} sellEndpoint={sellEndpoint}
                   marketPriceEndpoint={marketPriceEndpoint}
                   step={town.step} initialCount={property.goods_owned[name]} />
  </>);
}

export default SellGoods
